module.exports = __webpack_public_path__ + "img/happy.c687fb95.svg";